// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2oprU","delete":"styles_delete__1rKdP","update":"styles_update__3QzGO","add":"styles_add__3yZxJ"};